import {
  FormProvider,
  useForm,
} from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useIntl } from 'react-intl';

import { globalMessages } from '@/core/messages/global.messages';
import { TextField } from '@/core/components/TextField';
import { searchMessages } from '@/core/messages/search.messages';
import {
  IconButton,
  IconButtonSizes,
} from '@/core/components/IconButton';
import { ButtonVariant } from '@/core/components/Button';
import { Search } from '@/core/components/Icons';
import { TextFieldSizes } from '@/core/components/TextField/TextField.types';

import {
  ButtonWrapper,
  Form,
  FormWrapper,
} from './SearchForm.styles';

export type SearchDataType = {
  search: string;
};

type Props = {
  handleSearch: (searchPhrase: string) => void;
};

export const SearchForm = ({ handleSearch }: Props) => {
  const { formatMessage } = useIntl();
  const schema = yup.object().shape({
    search: yup
      .string()
      .min(3, formatMessage(searchMessages.fieldMessageToShort))
      .required(formatMessage(globalMessages.fieldRequired)),
  });

  const methods = useForm<SearchDataType>({
    mode: 'onBlur',
    resolver: yupResolver(schema),
  });
  const { handleSubmit } = methods;

  const onSubmit = (formData: SearchDataType) => {
    handleSearch(formData.search);
  };

  return (
    <FormWrapper>
      <FormProvider {...methods}>
        <Form
          onSubmit={handleSubmit(onSubmit)}
          noValidate
        >
          <TextField
            id="search"
            placeholder={formatMessage(searchMessages.placeholder)}
            withClearButton
            size={TextFieldSizes.HUGE}
          />
          <ButtonWrapper>
            <IconButton
              type="submit"
              variant={ButtonVariant.SECONDARY}
              size={IconButtonSizes.SMALL}
              icon={<Search />}
              ariaLabel={formatMessage(globalMessages.search)}
            />
          </ButtonWrapper>
        </Form>
      </FormProvider>
    </FormWrapper>
  );
};
